import { render, staticRenderFns } from "./Stage2.vue?vue&type=template&id=4aeb333a&scoped=true"
import script from "./Stage2.vue?vue&type=script&lang=js"
export * from "./Stage2.vue?vue&type=script&lang=js"
import style0 from "./Stage2.vue?vue&type=style&index=0&id=4aeb333a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb333a",
  null
  
)

export default component.exports